import { z } from 'zod';

export const purchaseOrderRecipientSchema = z.object({
  newRecipient: z
    .string()
    .trim()
    .pipe(z.email({ error: 'sendPoModalInvalidRecipient' })),
});

export type PurchaseOrderRecipientInput = z.input<
  typeof purchaseOrderRecipientSchema
>;

export type PurchaseOrderRecipientValues = z.infer<
  typeof purchaseOrderRecipientSchema
>;
